import { render, staticRenderFns } from "./AddEditVehicle.vue?vue&type=template&id=24132a90&scoped=true&"
import script from "./AddEditVehicle.vue?vue&type=script&lang=js&"
export * from "./AddEditVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24132a90",
  null
  
)

export default component.exports